import React from 'react'
import About from './About'
import Skills from './Skills'
import Historys from './Historys'
import Licence from './Licence'

export default function Right() {
  return (
    <div className='rihgt'>
        <div>
            <About/>
            <Skills/>
            <Historys/>
            <Licence/>
            <div className='gotoWrap'>
              <ul>
                <li><a href='https://github.com/magracarta'><img src='/image/gitIcon.png' alt='gitIcon.png'/></a></li>
                <li><a href='https://poised-magpie-c4b.notion.site/f254941208fc41dd9c99f3b31d233f07?pvs=74'><img src='/image/NotionIcon.png' alt='NotionIcon.png'/></a></li>
                {/* <li><a href=''><img src='/image/blogIcon.png' alt='blogIcon.png'/></a></li> */}
              </ul>
            </div>
        </div>
    </div>
  )
}
